import { v4 as uuidv4 } from "uuid";
import { useCollapsePanel } from "hooks/useCollapsePanel";
import { getName, phoneNumberFormatting } from "js/formatting";
import { useTranslation } from "react-i18next";
export default function AgentCard({ data }) {
  const uuid = uuidv4();
  const { t } = useTranslation();
  useCollapsePanel(uuid);

  return (
    <div className="ui-card mb-4 md:mb-6">
      <div className="md:flex md:flex-row md:items-start">
        <div className="px-4 pt-3 md:flex-grow xl:px-6 xl:pt-6">
          <h2 className="mb-0">
            <button
              id={uuid}
              className="flex items-center group md:hidden"
              aria-controls={`${uuid}-panel`}
              aria-expanded="true"
              aria-label="Expand or collapse Agent details"
            >
              <span className="inline-block p-1 rounded-full mr-2 text-ui-blue group-hover:text-white group-hover:bg-ui-blue">
                <svg
                  className="ui-icon ui-plus w-4 h-4"
                  focusable="false"
                  aria-hidden="true"
                  role="presentation"
                >
                  <use href="#ui-icon-plus"></use>
                </svg>
                <svg
                  className="ui-icon ui-minus w-4 h-4"
                  focusable="false"
                  aria-hidden="true"
                  role="presentation"
                >
                  <use href="#ui-icon-minus"></use>
                </svg>
              </span>
              <span className="text-base font-body font-bold md:ui-no-badge-icon-inline">
                {t("CustomerPolicyDetails-agent-title")}
              </span>
            </button>
            <span className="text-xl font-body font-bold hidden md:block">
              {t("CustomerPolicyDetails-agent-title")}
            </span>
          </h2>
        </div>
        <hr className="mb-0 mt-3 md:hidden" />
        <div className="hidden px-4 pt-4 text-sm md:justify-self-end md:px-6 md:pt-6">
          {/* <!-- Card title link --> */}
        </div>
      </div>
      <hr className="hidden md:block" />
      <div
        id={`${uuid}-panel`}
        className="px-4 pb-4 overflow-hidden h-20 md:h-auto xl:px-6 xl:pb-6"
      >
        {/* <!-- Agent Details --> */}
        {data.map((agent) => {
          const currentAgent = agent?.parties[0];
          const { addressLine1, addressLine2, city, state, postalCode } =
            currentAgent.address;
          const { phoneNumber } = currentAgent.phone;
          const { address: emailAddress } = currentAgent.email;
          return (
            <div
              key={`agent card - ${currentAgent.person.fullName}`}
              className="grid grid-cols-2 md:grid-cols-4 gap-2 xl:gap-2"
            >
              <div>
                <div className="text-xs text-theme-text-tertiary">
                  {t("CustomerPolicyDetails-agent-name")}
                </div>
                <div className="text-sm text-theme-text-secondary font-semibold">
                  {getName(currentAgent.person)}
                </div>
              </div>
              <div>
                <div className="text-xs text-theme-text-tertiary">
                  {t("CustomerPolicyDetails-agent-address")}
                </div>
                <div className="text-sm text-theme-text-secondary font-semibold break-words">
                  {addressLine1}
                  <br />
                  {addressLine2}
                </div>
                <div className="text-sm text-theme-text-secondary font-semibold">
                  {`${city}, ${state}`} {postalCode?.substring(0, 5)}
                </div>
              </div>
              <div>
                <div className="text-xs text-theme-text-tertiary">
                  {t("CustomerPolicyDetails-agent-phone")}
                </div>
                <div className="text-sm text-theme-text-secondary font-semibold">
                  <a href={`tel:+1${phoneNumber}`}>
                    {phoneNumberFormatting(phoneNumber)}
                  </a>
                </div>
              </div>
              <div>
                <div className="text-xs text-theme-text-tertiary">
                  {t("CustomerPolicyDetails-agent-email")}
                </div>
                <div className="text-sm text-theme-text-secondary font-semibold break-words">
                  <a href={`mailto:${emailAddress}`}>{emailAddress}</a>
                </div>
              </div>
            </div>
          );
        })}
        {/* <!-- Agent Details --> */}
      </div>
    </div>
  );
}
